import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import showmore from "../../assets/home/showmoreblue.png";
import AppointmentDetail from "./appointmentDetail";
import Appointmentsummary from "./appointmwntSummary";

const ReportsAppointments = () => {
  const [view, setView] = useState("Scheduled Maintenance Summary");
  const renderView = () => {
    let componentToRender = null;
    switch (view) {
      case "Scheduled Maintenance Summary":
        componentToRender = <Appointmentsummary />;
        break;
      case "Appointment Detail":
        componentToRender = <AppointmentDetail />;
        break;

      default:
        break;
    }
    return componentToRender;
  };

  const updateView = (key) => {
    setView(key);
  };
  return (
    <div className="reports-appointment pool-set-up search-invoice">
      <div className="target-heading client-profile">
        <>
          <div className="">
            <h3>{view}</h3>
          </div>
          {/* <div className="content-dropdown">
            <div className="client-option service-edit-icon">
              <Dropdown>
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  <img src={showmore} alt="show" />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item>
                    <div className="action" onClick={() => updateView('Scheduled Maintenance Summary')}>
                      <span>Scheduled Maintenance Summary</span>
                    </div>
                  </Dropdown.Item>
                  <Dropdown.Item>
                    <div className="action" onClick={() => updateView('Appointment Detail')}>
                      <span>Appointment Detail</span>
                    </div>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div> */}
        </>
      </div>
      {renderView()}
    </div>
  );
};
export default ReportsAppointments;
